import React from "react";
import { ArrowUpRight } from "lucide-react";
import { APP_URL } from "@/data/landing";
import { Btn } from "@/components/landing/primitives";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="pb-24 lg:pb-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="relative rounded-[2.5rem] bg-afwn-navy afwn-grain overflow-hidden px-8 py-16 lg:py-24 text-center">
        <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-afwn-magenta/20 blur-3xl" />
        <div className="absolute -bottom-24 -right-16 w-80 h-80 rounded-full bg-afwn-amber/20 blur-3xl" />
        <div className="relative max-w-2xl mx-auto">
          <h2 className="font-heading font-light tracking-tight text-4xl lg:text-6xl text-white leading-[1.1]">Your 7-day calm<br />journey starts today.</h2>
          <p className="mt-5 text-lg text-white/70">Try every AI assistant and the full wellness program free for a week — practical self-help tools and support that’s always there.</p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
            <Btn href={APP_URL} data-testid="final-cta-button" variant="amber">Start your 7 Day to Calm Journey <ArrowUpRight size={18} /></Btn>
          </div>
        </div>
      </div>
    </div>
  </section>
);
